module.exports = __webpack_public_path__ + "static/media/bajopiso_acustica.20e272a8.jpg";